import { render, staticRenderFns } from "./DeliverDialog.vue?vue&type=template&id=16d364f4&"
import script from "./DeliverDialog.vue?vue&type=script&lang=js&"
export * from "./DeliverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports